// @ts-expect-error Untyped
import initializeApp from './initializeApp';
initializeApp();